import { render } from "./DashboardSevenDay.vue?vue&type=template&id=1979e0d6&scoped=true&ts=true"
import script from "./DashboardSevenDay.vue?vue&type=script&lang=ts"
export * from "./DashboardSevenDay.vue?vue&type=script&lang=ts"

import "./DashboardSevenDay.vue?vue&type=style&index=0&id=1979e0d6&scoped=true&lang=css"
import "./DashboardSevenDay.vue?vue&type=style&index=1&id=1979e0d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1979e0d6"]])

export default __exports__